import mixpanel from 'mixpanel-browser';
import * as React from 'react';

import { isMixpanelEnabled } from '../lib/mixpanel';
import { useAuthState } from '../providers/AuthProvider';

const MixpanelIdentifier = () => {
  const { user } = useAuthState();

  React.useEffect(() => {
    if (isMixpanelEnabled()) {
      if (user) {
        mixpanel.identify(user.id);
        mixpanel.people.set({
          $email: user.email,
          $name: user.name,
          $first_name: user.firstName,
          $last_name: user.lastName,
          $created: user.createdAt,
        });
      } else {
        mixpanel.reset();
      }
    }
  }, [user]);

  return null;
};

export default MixpanelIdentifier;
